// extracted by mini-css-extract-plugin
export default {"title":"modal-small_title__wdTbb","text":"modal-small_text__S3X0T","btn_box":"modal-small_btn_box__Venlf","btn":"modal-small_btn__InKZn"};